module.exports = __webpack_public_path__ + "static/0039-acb6e46fce077f131967ef664fce828f.png";